
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "20px",
    "height": "20px",
    "viewBox": "0 0 20 20",
    "enable-background": "new 0 0 20 20",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "20",
        "height": "20"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "x": "2",
        "y": "7.838",
        "fill": "#AEE4FA",
        "width": "16",
        "height": "9.162"
      }
    },
    {
      "tag": "polygon",
      "attrsMap": {
        "fill": "#AEE4FA",
        "points": "18,6.977 2,6.977 3.886,4 8.794,4 10.911,5.756 18,5.756 "
      }
    }
  ]
})
    }
  